import * as React from 'react'

import BlueGridContainer from 'components/blue-grid-container/BlueGridContainer'
import { FeaturesGrid, Feature } from 'components/features-grid/FeaturesGrid'
import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'

import { useWindowSize } from 'core/hooks/useWindowSize'
import type { PlatformGearsCmsContent } from 'core/services/cms/interfaces'

import classes from './style.module.scss'

interface GearsSectionProps {
  content: PlatformGearsCmsContent
}

export const GearsSection: React.FC<GearsSectionProps> = ({ content }) => {
  const { width } = useWindowSize()
  const isAboveMd = width > 768
  const features: Feature[] = content.features.map((feature) => ({
    icon: feature.iconUrl,
    title: feature.title,
  }))

  return (
    <BlueGridContainer>
      <div className={classes.textContainer}>
        <Text type={TextName.H2}>{content.title}</Text>

        <Text type={TextName.Text} className={classes.description}>
          {content.description}
        </Text>
      </div>

      <img
        src={isAboveMd ? content.desktopBackgroundUrl : content.mobileBackgroundUrl}
        alt='GEARS'
        className={classes.backgroundImage}
      />

      <FeaturesGrid features={features} className={classes.featuresGrid} />

      <div className={classes.buttonContainer}>
        <Button
          as='link'
          href='https://github.com/gpuaudio/gpuaudio-sdk/tree/main?tab=readme-ov-file#gpu-audio-engine-and-scheduler'
          target='_blank'
        >
          Learn More
        </Button>
      </div>
    </BlueGridContainer>
  )
}
